module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/da61b68758e268acdb29dd76950b76b0.png";